import axios from "axios";
import routes from "@/routes/routes";
import { isEmpty } from "@/utils/index";

// create an axios instance
const service = axios.create({
  baseURL: isEmpty(process.env.BASE_API)? "http://new.wifiexc.cn/api" : process.env.BASE_API,
  // request timeout
  timeout: 50000
});

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent

    return config;
  },
  error => {
    // Do something with request error
    //console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  // response => response,
  response => {
    const res = response.data;
    if (res.code === 401) {
      // routes.push({ path: "home" });
      notify({
        message: "登录已过期",
        type: "error"
      });
      return response;
    } else if (res.code !== 200 && res.code !== 401) {
      // notify({
      //   message: res.message,
      //   type: "error"
      // });
    }
    return response;
  },
  error => {
    //console.log("err" + error); // for debug
    // notify({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);

export default service;
